export enum SignUpOrLoginType {
  Facebook = 'facebook',
  Email = 'email',
  Google = 'google',
}
